import { createSelector } from 'reselect'
import { selectPricings } from './selectPricings'

export const selectHasPlans = createSelector(selectPricings, pricings => {
  return pricings.length !== 0
})
